import ShoppingListsPage from './ShoppingListsPage';

export default ShoppingListsPage;
